var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackdevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 1H5C3.89543 1 3 1.89543 3 3V14H10H2.5C1.67157 14 1 14.6716 1 15.5C1 16.3284 1.67157 17 2.5 17H10M15 17H19C20.1046 17 21 16.1046 21 15V6C21 4.89543 20.1046 4 19 4H15C13.8954 4 13 4.89543 13 6V15C13 16.1046 13.8954 17 15 17Z",
    stroke: "#3C7795",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackdevice);
export default __webpack_public_path__ + "static/media/trackdevice.d7a6ec0dcfffc440d6d90b606d586cfb.svg";
export { ForwardRef as ReactComponent };